module.exports = __webpack_public_path__ + "img/horizontal_6_7_8004.ce48c59c.png";